import { GetNearbyCitiesResponse } from '../../api/nearbyCities';
import type { ThingsToDoShelfTag } from '@/src/homepage/shared/types';
import { RootState } from '../store';
export const FETCH_TTD_SHELF_DATA = 'FETCH_TTD_SHELF_DATA';
export const FETCH_TTD_SHELF_DATA_SUCCESS = 'FETCH_TTD_SHELF_DATA_SUCCESS';
export const FETCH_TTD_SHELF_DATA_FAILURE = 'FETCH_TTD_SHELF_DATA_FAILURE';

export const thingsToDoShelfDataInProgress = () => ({
    type: FETCH_TTD_SHELF_DATA,
});

export const thingsToDoShelfSuccess = <T>(data: T) => ({
    type: FETCH_TTD_SHELF_DATA_SUCCESS,
    payload: data,
});

export const thingsToDoShelfFailure = () => ({
    type: FETCH_TTD_SHELF_DATA_FAILURE,
});

const transformIntoThingsToDoShelfData = (
    slug: string,
    response: GetNearbyCitiesResponse,
    usesLanguageSubdirectory: boolean,
    locale?: string,
) => {
    const { buckets, place } = response;

    if (!buckets || !buckets.length) {
        return {
            tags: [],
            header: { placeName: '', url: '' },
        };
    }

    const tags: ThingsToDoShelfTag[] = [];

    buckets.slice(0, 12).forEach((place: ThingsToDoShelfTag) => {
        if (place.linkUrl) {
            let url = usesLanguageSubdirectory
                ? place.linkUrl.replace('/d/', `/${locale}/ttd/`)
                : place.linkUrl.replace('/d/', '/ttd/');
            url = url.replace('/events/', '/');
            tags.push({
                placeName: place.placeName,
                linkUrl: url,
            });
        }
    });

    let headerUrl = `/ttd/${slug}/`;
    headerUrl = usesLanguageSubdirectory ? '/' + locale + headerUrl : headerUrl;
    const header = {
        placeName: place.name,
        url: headerUrl,
    };

    return {
        tags,
        header,
    };
};

export const fetchThingsToDoShelfData =
    () =>
    async (
        dispatch: (action: ReturnType<typeof thingsToDoShelfDataInProgress>) => void,
        getState: () => RootState,
    ) => {
        const {
            location: { placeId, isOnline, slug },
            app,
        } = getState();

        dispatch(thingsToDoShelfDataInProgress());

        if (isOnline || !placeId) return;

        try {
            const data = await fetch(`/home/api/nearby_cities/?placeId=${placeId}`, { cache: 'no-store' });
            const json: GetNearbyCitiesResponse = await data.json();

            dispatch(
                thingsToDoShelfSuccess(
                    transformIntoThingsToDoShelfData(
                        slug,
                        json,
                        app.uses_language_subdirectory,
                        app.locale,
                    ),
                ),
            );
        } catch (error) {
            console.error('Error fetching nearby cities:', error);
            dispatch(thingsToDoShelfFailure());
        }
    };
